export enum TokenPurpose {
	INVITATION = "INVITATION",
	FORGOTTEN_PASSWORD = "FORGOTTEN_PASSWORD",
	CHANGE_EMAIL = "CHANGE_EMAIL",
}
